import React from 'react'
import Gallery from '../../components/Gallery'
import SEO from '../../components/SEO'
import SubMenu from '../../components/SubMenu'

const editorialPage = ({ data, transition }) => (
  <div>
    <SubMenu thisName={'Editorial'} />
    <div style={transition && transition.style}>
      <SEO slug={'editorial'} />
      <Gallery sizes={data.editorial.edges} />
    </div>
  </div>
)

export default editorialPage



// WEBPACK FOOTER //
// ./src/pages/editorial/index.js